import React from 'react'
import styled from 'styled-components'

const FileItem = ( { file } ) => {

  const displaySize = ( size ) => {
    if ( size < 1024 ) {
      return `${size} bytes`
    } else if ( size < 1048576 ) {
      return `${( size / 1024 ).toFixed( 2 )} KB`
    } else {
      return `${( size / 1048576 ).toFixed( 2 )} MB`
    }
  }

  return (
    <StyledFileItem>
      <div className="left">
        <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 64 64" x="0px" y="0px"><path d="M57.6108,17.6514,41.0049,1.2876A1,1,0,0,0,40.3032,1H9.8584A3.7516,3.7516,0,0,0,6.0908,4.7271V59.2729A3.7516,3.7516,0,0,0,9.8584,63H54.1416a3.7516,3.7516,0,0,0,3.7676-3.7271V18.3638A1,1,0,0,0,57.6108,17.6514ZM41.3032,4.39,54.47,17.3638H41.3032ZM54.1416,61H9.8584a1.75,1.75,0,0,1-1.7676-1.7271V4.7271A1.75,1.75,0,0,1,9.8584,3H39.3032V18.3638a1,1,0,0,0,1,1h15.606V59.2729A1.75,1.75,0,0,1,54.1416,61Z" /><path d="M39.729,38.2314A.9991.9991,0,0,0,38.3,38.0332l-6.1709,4.8647-7.6782-8.8271a1,1,0,0,0-1.6084.1362L14.54,47.8438a1,1,0,0,0,.854,1.52H45.8384a1,1,0,0,0,.8095-1.5869ZM17.1738,47.3638,23.84,36.415l7.4058,8.5142a.9986.9986,0,0,0,1.3735.1289l6.1016-4.81,5.1577,7.1158Z" /><path d="M24.3887,28.9092a5.7731,5.7731,0,1,0-5.8433-5.773A5.8154,5.8154,0,0,0,24.3887,28.9092Zm0-9.5454a3.7733,3.7733,0,1,1-3.8433,3.7724A3.8128,3.8128,0,0,1,24.3887,19.3638Z" /></svg>

      </div>
      <div className="right">
        <p className="name">{file.name}</p>
        <p className="size">{displaySize(file.size)}</p>
      </div>
    </StyledFileItem>
  )
}

const StyledFileItem = styled.div`
  display: flex;
  align-items: center;
  padding: .7rem;
  border: 1px solid #ccccccaa;
  border-radius: 5px;

  .left {
    width: 50px;
    padding-right: .7rem;
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    p {
      margin: 5px;
    }
  }
`

export default FileItem